import NotificationActions from '../../../actions/NotificationActions';

import UserStore from '../../../stores/UserStore';
import ConfigStore from '../../../stores/ConfigStore';
import PermissionStore from '../../../stores/PermissionStore';
import { Permissions } from '../../../constants/PermissionConstants';

import { endPoints as EndPoints } from '../../../constants/GuestConstants';
import AjaxPromises from '../../../utils/AjaxPromises';

class JournalButton extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            loading : false
        };

        this.save = this.save.bind(this);
        this.isButtonDisabled = this.isButtonDisabled.bind(this);
    }

    save() {
        var self = this;

        if (this.isButtonDisabled())
            return;

        var formData        = UserStore.getApiData();
        formData.NoteId     = this.props.selected ? this.props.selected.NoteId : 0;
        formData.Guest_id   = this.props.guest.Guest_id;
        formData.Subject    = this.props.subject;
        formData.Note       = this.props.body;

        this.setState({ loading : true }, () => {
            AjaxPromises.POST(EndPoints.UPDATE_JOURNAL_NOTE,
                formData).then(res => {
                    
                    NotificationActions.addNotification({
                        type : res.Result ? 'success' : 'error',
                        body : res.Result ? 'Journal Note Added' : res.Message
                    });

                    if (res.Result) {
                        self.props.onRefresh();
                    }
                }
            );
        });
    }

    isButtonDisabled() {
        var disabled = false;
        var selected = this.props.selected;
        var subject  = this.props.subject;
        var body     = this.props.body;

        if (subject.length < 1 || body.length < 1 || (selected && subject === selected.NoteSubject && body === selected.Note)) {
            disabled = true;
        } 

        if (!PermissionStore.userCan(Permissions.EditPatientJournalEntries) && selected != false) {
            disabled = true;
        }

        return disabled;
    }

    render() {
        var selected = this.props.selected;

        if (this.props.html) {
            return null;
        }

        var label    = !selected ? 'SAVE' : 'UPDATE';
        var disabled = this.isButtonDisabled();

        return (
            <button
                className={'btn-green '+(disabled ? 'btn-green__disabled' : '')}
                onClick={this.save}
                disabled={disabled}>

                {label}
            </button>
        );
    }
}

export default JournalButton;



// WEBPACK FOOTER //
// ./ui_src/app/components/popup/journal/JournalButton.react.jsx